export default __webpack_public_path__ + "media/images/react_icons/hamburguer_menu-ed04ee2aff8a19dbe08809af5a5220bb.svg";